var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_183_1",
    "data-name": "Componente 183 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170798",
    "data-name": "Grupo 170798",
    transform: "translate(-761 -410)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_295",
    "data-name": "Elipse 295",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(767 416)",
    fill: "#7ac810"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170796",
    "data-name": "Grupo 170796",
    transform: "translate(0.173 -1.503)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_203",
    "data-name": "Elipse 203",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(780.644 437.84)",
    fill: "#417200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_210",
    "data-name": "Trazado 210",
    d: "M365.48,1379.544a5.8,5.8,0,0,0-1.705-.632,4.735,4.735,0,0,0-1.832-.016,4.307,4.307,0,0,0-1.694.705,6.683,6.683,0,0,0-1.42,1.323l-.039.045a.729.729,0,0,1-1.132-.916,8.206,8.206,0,0,1,1.663-1.743,5.963,5.963,0,0,1,2.245-1.093,6.518,6.518,0,0,1,2.5-.133,7.549,7.549,0,0,1,2.415.753.991.991,0,0,1-.9,1.768l-.054-.029Z",
    transform: "translate(420.316 -945.519)",
    fill: "#417200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_211",
    "data-name": "Trazado 211",
    d: "M426.469,1525.623c4.053,0,7.4-2.662,7.939-6.117a.6.6,0,0,0-.772-.667,20.322,20.322,0,0,1-14.334,0,.6.6,0,0,0-.772.668C419.064,1522.96,422.415,1525.623,426.469,1525.623Z",
    transform: "translate(366.748 -1070.006)",
    fill: "#417200"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_204",
    "data-name": "Elipse 204",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(800.626 437.84)",
    fill: "#417200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_212",
    "data-name": "Trazado 212",
    d: "M532.334,1377.838a7.551,7.551,0,0,1,2.415-.753,6.519,6.519,0,0,1,2.5.133,5.962,5.962,0,0,1,2.245,1.093,8.21,8.21,0,0,1,1.663,1.743.729.729,0,0,1-1.131.918l-.041-.047a6.681,6.681,0,0,0-1.42-1.323,4.307,4.307,0,0,0-1.694-.705,4.735,4.735,0,0,0-1.832.016,5.8,5.8,0,0,0-1.705.632l-.052.031a.992.992,0,0,1-1.01-1.707Z",
    transform: "translate(267.297 -945.519)",
    fill: "#417200"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148767",
    "data-name": "Rect\\xE1ngulo 148767",
    width: 64,
    height: 64,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.fba177986f9de5c5796bb97477fa058a.svg";
export { ForwardRef as ReactComponent };